import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const PublicationCard = () => {
    return (
        <div className="col-md-6">
            <div className=" publication-card-container ">
                <div className="pb-0">
                    <h6 className="">Exploiting Application Tolerance for Functional Safety</h6>
                    <p className="institute-text">IEEE International Test Conference</p>

                </div>
                <div >
                    <p className="text-muted pb-1">Prasanth V P, Rubin Parekhji, Bharadwaj Amrutur</p>
                    <div className="  d-flex justify-content-between">
                        <small className="muted-text">2021</small>
                        <p className=" m-0 p-0 read-more">Read More  <span className="ms-1"><FontAwesomeIcon icon={faChevronRight} /></span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicationCard;